// Sample data for LuigisHallofShame.com
// This represents the extreme price disparities in US healthcare

export const sampleHospitals = [
  {
    id: "hospital-1",
    name: "MegaProfit Medical Center",
    city: "New York",
    state: "NY",
    shameScore: 847,
    worstOvercharge: {
      procedure: "Basic Blood Test",
      markup: 2400,
      price: 2500
    }
  },
  {
    id: "hospital-2", 
    name: "GoldPlated General Hospital",
    city: "Beverly Hills",
    state: "CA",
    shameScore: 623,
    worstOvercharge: {
      procedure: "Emergency Room Visit",
      markup: 1200,
      price: 4500
    }
  },
  {
    id: "hospital-3",
    name: "PriceMaster Regional",
    city: "Dallas",
    state: "TX", 
    shameScore: 734,
    worstOvercharge: {
      procedure: "CT Scan",
      markup: 800,
      price: 9200
    }
  },
  {
    id: "hospital-4",
    name: "OverCharge Memorial",
    city: "Miami",
    state: "FL",
    shameScore: 567,
    worstOvercharge: {
      procedure: "MRI Scan",
      markup: 650,
      price: 5400
    }
  },
  {
    id: "hospital-5",
    name: "ExcessCorp Health System",
    city: "Chicago",
    state: "IL",
    shameScore: 489,
    worstOvercharge: {
      procedure: "Routine Checkup",
      markup: 400,
      price: 850
    }
  }
];

export const sampleComparisons = [
  {
    procedure: "Normal Childbirth Delivery",
    usPrice: 32093,
    internationalPrices: [
      { country: "Canada", price: 0, flag: "🇨🇦" },
      { country: "UK", price: 0, flag: "🇬🇧" },
      { country: "France", price: 0, flag: "🇫🇷" },
      { country: "Netherlands", price: 0, flag: "🇳🇱" }
    ]
  },
  {
    procedure: "Heart Attack Treatment",
    usPrice: 185000,
    internationalPrices: [
      { country: "Germany", price: 7800, flag: "🇩🇪" },
      { country: "Australia", price: 0, flag: "🇦🇺" },
      { country: "Canada", price: 0, flag: "🇨🇦" },
      { country: "Japan", price: 3500, flag: "🇯🇵" }
    ]
  },
  {
    procedure: "Prostate Cancer Treatment (Full Course)",
    usPrice: 450000,
    internationalPrices: [
      { country: "UK", price: 0, flag: "🇬🇧" },
      { country: "Germany", price: 15000, flag: "🇩🇪" },
      { country: "Canada", price: 0, flag: "🇨🇦" },
      { country: "France", price: 0, flag: "🇫🇷" }
    ]
  },
  {
    procedure: "CAR-T Gene Therapy (Cancer)",
    usPrice: 850000,
    internationalPrices: [
      { country: "Germany", price: 180000, flag: "🇩🇪" },
      { country: "UK", price: 0, flag: "🇬🇧" },
      { country: "Canada", price: 0, flag: "🇨🇦" },
      { country: "Australia", price: 0, flag: "🇦🇺" }
    ]
  },
  {
    procedure: "Single Dose of Tylenol (Hospital)",
    usPrice: 89,
    internationalPrices: [
      { country: "CVS Pharmacy", price: 0.50, flag: "💊" },
      { country: "Canada", price: 0.25, flag: "🇨🇦" },
      { country: "UK", price: 0.15, flag: "🇬🇧" },
      { country: "Germany", price: 0.20, flag: "🇩🇪" }
    ]
  },
  {
    procedure: "Surgical Gloves (Per Pair)",
    usPrice: 75,
    internationalPrices: [
      { country: "Amazon", price: 0.15, flag: "📦" },
      { country: "Germany", price: 0.12, flag: "🇩🇪" },
      { country: "China", price: 0.08, flag: "🇨🇳" },
      { country: "India", price: 0.05, flag: "🇮🇳" }
    ]
  },
  {
    procedure: "Listerine Mouthwash (Small Bottle)",
    usPrice: 45,
    internationalPrices: [
      { country: "Target", price: 3.99, flag: "🎯" },
      { country: "Canada", price: 4.25, flag: "🇨🇦" },
      { country: "UK", price: 3.50, flag: "🇬🇧" },
      { country: "Germany", price: 4.10, flag: "🇩🇪" }
    ]
  },
  {
    procedure: "Emergency Room Visit (No Treatment)",
    usPrice: 4500,
    internationalPrices: [
      { country: "Canada", price: 0, flag: "🇨🇦" },
      { country: "UK", price: 0, flag: "🇬🇧" },
      { country: "France", price: 25, flag: "🇫🇷" },
      { country: "Germany", price: 50, flag: "🇩🇪" }
    ]
  },
  {
    procedure: "MRI Scan",
    usPrice: 5400,
    internationalPrices: [
      { country: "Canada", price: 800, flag: "🇨🇦" },
      { country: "Germany", price: 650, flag: "🇩🇪" },
      { country: "Japan", price: 720, flag: "🇯🇵" },
      { country: "Australia", price: 890, flag: "🇦🇺" }
    ]
  },
  {
    procedure: "Insulin (Monthly Supply)",
    usPrice: 3200,
    internationalPrices: [
      { country: "Canada", price: 80, flag: "🇨🇦" },
      { country: "UK", price: 0, flag: "🇬🇧" },
      { country: "Germany", price: 45, flag: "🇩🇪" },
      { country: "Mexico", price: 25, flag: "🇲🇽" }
    ]
  }
];

export const dailyOvercharges = 2847293847; // Sample daily overcharge amount

export const topOffenders = sampleHospitals.slice(0, 3);

export const procedureCategories = [
  "Emergency Care",
  "Diagnostic Imaging", 
  "Laboratory Tests",
  "Surgical Procedures",
  "Outpatient Visits",
  "Inpatient Care"
];

export const commonProcedures = [
  "Basic Blood Test",
  "CT Scan",
  "MRI Scan", 
  "Emergency Room Visit",
  "Routine Checkup",
  "X-Ray",
  "Appendectomy",
  "Childbirth Delivery",
  "Heart Surgery",
  "Kidney Stone Treatment"
];